export const wrapperUndoStyles = {
  spacing: 7,
  width: '100%',
  alignItems: 'center',
  marginTop: 8,
};
